"use client";

import { useEffect } from "react";
import { captureAppException } from "@/lib/posthogInit";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    captureAppException(error, { context: 'global-error' });
  }, [error]);

  return (
    <html lang="en">
      <body className="bg-white text-gray-900 dark:bg-gray-950 dark:text-gray-100">
        <main id="main-content" className="min-h-screen flex items-center justify-center p-6">
          <div className="max-w-lg w-full rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-8 shadow-sm">
            <p className="text-sm font-medium text-red-600 dark:text-red-400 mb-2">Application error</p>
            <h1 className="text-2xl font-semibold mb-3">Something went wrong</h1>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">
              An unexpected error occurred. Try reloading the page or use the support links below.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="inline-flex items-center justify-center rounded-xl bg-gray-950 px-4 py-3 text-sm font-medium text-white dark:bg-white dark:text-black"
              >
                Reload page
              </button>
              <a
                href="https://staff.blockly.website/support"
                className="inline-flex items-center justify-center rounded-xl border border-gray-300 dark:border-gray-700 px-4 py-3 text-sm font-medium"
              >
                Troubleshooting docs
              </a>
              <a
                href="mailto:support@blockly.website?subject=Admin%20app%20error"
                className="inline-flex items-center justify-center rounded-xl border border-gray-300 dark:border-gray-700 px-4 py-3 text-sm font-medium"
              >
                Report this issue
              </a>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
